import module from 'nominas/finiquito/module.js'

const schema = {
  id_escenario: 'number',
  aplicar_baja: 'boolean',
}

export class NominasFiniquitoIdnominaService {
  constructor ($http) {
    this.$http = $http
  }

  post (idProyecto, idColaborador, idFiniquito, data) {
    return this.$http.post('/api/nominas/finiquitos/finiquito/id-nomina', data, {
      params: {
        id_proyecto: idProyecto,
        id_colaborador: idColaborador,
        id_finiquito: idFiniquito,
      },
      schema,
    })
  }

  delete (idProyecto, idColaborador, idFiniquito) {
    return this.$http.delete('/api/nominas/finiquitos/finiquito/id-nomina', {
      params: {
        id_proyecto: idProyecto,
        id_colaborador: idColaborador,
        id_finiquito: idFiniquito,
      },
      schema,
    })
  }
}

module.service('NominasFiniquitoIdnomina', NominasFiniquitoIdnominaService)



// WEBPACK FOOTER //
// ./src/nominas/finiquito/services/Finiquito/Idnomina.js